'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifierConfig = undefined;

var _decisivUiUtils = require('decisiv-ui-utils');

var _elements = require('../../elements');

var modifierConfig = exports.modifierConfig = {
  icon: function icon() {
    return '\n    max-width: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  ';
  }
};

var styles = function styles() {
  return '\n  height: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  margin: ' + (0, _decisivUiUtils.px2rem)(8) + ';\n';
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('MenuItemTitleGhost', _elements.GhostIndicator, styles, { modifierConfig: modifierConfig });


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/LeftNav/MenuItemTitleGhost.js
// module id = 1587
// module chunks = 2